module.exports = __webpack_public_path__ + "static/media/s-white-on-black-logo.37e8fd0d.png";